import { render } from "./UsersListView.vue?vue&type=template&id=24b49246"
import script from "./UsersListView.vue?vue&type=script&lang=js"
export * from "./UsersListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__